import React from 'react';
import Alias from './alias';

// Shared AG Grid "alias" column cell renderer, used by every list of identified objects (debugger
// sessions, the Select Session modal, scheduler schedules) so the treatment is defined once.
//
// Two decisions worth keeping: the cell is NOT the row's link — the ID column stays first and keeps
// that job, because the pill sets its own color and would lose the link affordance — and an absent
// alias does NOT fall back to the row's UUID. The alias is optional and omitted from responses
// entirely when unset, so absence is ordinary; it gets the same muted placeholder the sibling
// Description column uses rather than repeating the id that is already in the column next door.
//
// AgGridReact does not render meaningfully under jsdom, so this is exported and tested directly.
export function aliasCellRenderer(params) {
  if ( !params.value ) {
    return ( <span className="text-muted">No alias</span> );
  }
  return ( <Alias value={params.value} /> );
}
